export const emHomeBlokFakeData: any = {
  blok: {
    _uid: '3ee60d5e-560f-4858-88c3-d8382544a73e',
    component: 'em_home',
    card_xlarge: [
      {
        _uid: 'e1da05c1-9751-4031-87f2-a3653084ea7f',
        link: {
          id: '',
          url: '/404',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: '/404',
        },
        image: {
          id: 16640941,
          alt: 'Multiple coffee machines',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename: 'https://a.storyblok.com/f/267357/1600x1200/c7f1e5eecc/em_home-coffee-machines.jpg',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Multiple coffee machines',
            title: '',
            source: '',
            copyright: '',
          },
          is_private: false,
          is_external_url: false,
        },
        video: {
          id: null,
          alt: null,
          name: '',
          focus: null,
          title: null,
          source: null,
          filename: '',
          copyright: null,
          fieldtype: 'asset',
          meta_data: {},
        },
        is_dark: true,
        subline: '',
        headline: 'The perfect fit for your industry.',
        overline: 'WMF Professional Coffee Machines',
        component: 'em_home--card-xlarge',
        text_layout: 'overline_headline',
        _editable:
          '<!--#storyblok#{"name": "em_home--card-xlarge", "space": "267357", "uid": "e1da05c1-9751-4031-87f2-a3653084ea7f", "id": "522364930"}-->',
      },
    ],
    other_cards: [
      {
        _uid: 'cae76c84-05f6-471a-849d-26aacadbb4f3',
        component: 'em_home-col-1-medium-1-small',
        small_card: [
          {
            _uid: 'b6e8d91d-c3ab-4308-970f-340d994d8e39',
            link: {
              id: '',
              url: '',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: '',
            },
            is_dark: true,
            component: 'em_home--card-small',
            back_side_cta: {
              id: '',
              url: '/404',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: '/404',
            },
            interactivity: 'flip',
            back_side_text: 'Donec potenti',
            front_side_image: {
              id: 16640949,
              alt: 'A graphic of a toggle',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename: 'https://a.storyblok.com/f/267357/1252x1252/980fe8337c/em_home-toggle.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A graphic of a toggle',
                title: '',
                source: '',
                copyright: '',
              },
              is_private: false,
              is_external_url: false,
            },
            front_side_video: {
              id: null,
              alt: null,
              name: '',
              focus: null,
              title: null,
              source: null,
              filename: '',
              copyright: null,
              fieldtype: 'asset',
              meta_data: {},
            },
            front_side_headline: 'Basic to premium support.',
            vertical_text_align: 'bottom',
            _editable:
              '<!--#storyblok#{"name": "em_home--card-small", "space": "267357", "uid": "b6e8d91d-c3ab-4308-970f-340d994d8e39", "id": "522364930"}-->',
          },
        ],
        medium_card: [
          {
            _uid: '5ca94c32-ec59-4f08-9c33-c9f79446aacd',
            link: {
              id: '',
              url: '/404',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: '/404',
            },
            is_dark: true,
            component: 'em_home--card-medium',
            text_layout: 'overline_headline',
            back_side_cta: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            interactivity: 'link',
            back_side_text: '',
            front_side_image: {
              id: 16640943,
              alt: 'A coffee shop employee holding a tablet',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename: 'https://a.storyblok.com/f/267357/2121x1414/3abe16fb8a/em_home-staff-with-tablet.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A coffee shop employee holding a tablet',
                title: '',
                source: '',
                copyright: '',
              },
              is_private: false,
              is_external_url: false,
            },
            front_side_video: {
              id: null,
              alt: null,
              name: '',
              focus: null,
              title: null,
              source: null,
              filename: '',
              copyright: null,
              fieldtype: 'asset',
              meta_data: {},
            },
            front_side_subline: '',
            front_side_headline: 'Don’t settle for less.',
            front_side_overline: 'We are industry experts.',
            vertical_text_align: 'bottom',
            _editable:
              '<!--#storyblok#{"name": "em_home--card-medium", "space": "267357", "uid": "5ca94c32-ec59-4f08-9c33-c9f79446aacd", "id": "522364930"}-->',
          },
        ],
        medium_card_position: 'top',
        _editable:
          '<!--#storyblok#{"name": "em_home-col-1-medium-1-small", "space": "267357", "uid": "cae76c84-05f6-471a-849d-26aacadbb4f3", "id": "522364930"}-->',
      },
      {
        _uid: 'b12e47d7-7cb7-4b24-9b52-f98c0502f104',
        component: 'em_home-col-1-large-2-small',
        large_card: [
          {
            _uid: '455a4767-af30-4387-9faa-587535f66ddf',
            link: {
              id: '',
              url: '/404',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: '/404',
            },
            image: {
              id: 16640936,
              alt: 'A picture of a woman dancing',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename: 'https://a.storyblok.com/f/267357/3814x2147/d4be1cb6d8/em_home-dancer.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A picture of a woman dancing',
                title: '',
                source: '',
                copyright: '',
              },
              is_private: false,
              is_external_url: false,
            },
            video: {
              id: null,
              alt: null,
              name: '',
              focus: null,
              title: null,
              source: null,
              filename: '',
              copyright: null,
              fieldtype: 'asset',
              meta_data: {},
            },
            is_dark: true,
            subline: '',
            headline: 'Perfektion in jeder Wiederholung.',
            overline: 'WMF espresso NEXT',
            component: 'em_home--card-large',
            text_layout: 'overline_headline',
            vertical_text_align: 'bottom',
            _editable:
              '<!--#storyblok#{"name": "em_home--card-large", "space": "267357", "uid": "455a4767-af30-4387-9faa-587535f66ddf", "id": "522364930"}-->',
          },
        ],
        small_cards: [
          {
            _uid: 'ba5c9b57-5537-4733-8f8f-64f4458d8ef0',
            link: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            is_dark: true,
            component: 'em_home--card-small',
            back_side_cta: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            interactivity: 'none',
            back_side_text: '',
            front_side_image: {
              id: 16640938,
              alt: 'A photo of smoke',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename: 'https://a.storyblok.com/f/267357/3182x4096/69f543b9dc/em_home-smoke.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A photo of smoke',
                title: '',
                source: '',
                copyright: '',
              },
              is_private: false,
              is_external_url: false,
            },
            front_side_video: {
              id: null,
              alt: null,
              name: '',
              focus: null,
              title: null,
              source: null,
              filename: '',
              copyright: null,
              fieldtype: 'asset',
              meta_data: {},
            },
            front_side_headline: 'Excellent coffee quality.',
            vertical_text_align: 'center',
            _editable:
              '<!--#storyblok#{"name": "em_home--card-small", "space": "267357", "uid": "ba5c9b57-5537-4733-8f8f-64f4458d8ef0", "id": "522364930"}-->',
          },
          {
            _uid: '9c83b16f-5ea2-4f92-8253-1a6a198bb9a3',
            link: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            is_dark: true,
            component: 'em_home--card-small',
            back_side_cta: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            interactivity: 'none',
            back_side_text: '',
            front_side_image: {
              id: 16640948,
              alt: 'A graphic of chat bubbles',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename: 'https://a.storyblok.com/f/267357/1252x1252/6efa5a2ace/em_home-chat-bubbles.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A graphic of chat bubbles',
                title: '',
                source: '',
                copyright: '',
              },
              is_private: false,
              is_external_url: false,
            },
            front_side_video: {
              id: null,
              alt: null,
              name: '',
              focus: null,
              title: null,
              source: null,
              filename: '',
              copyright: null,
              fieldtype: 'asset',
              meta_data: {},
            },
            front_side_headline: 'Get the conversation started.',
            vertical_text_align: 'bottom',
            _editable:
              '<!--#storyblok#{"name": "em_home--card-small", "space": "267357", "uid": "9c83b16f-5ea2-4f92-8253-1a6a198bb9a3", "id": "522364930"}-->',
          },
        ],
        large_card_position: 'top',
        _editable:
          '<!--#storyblok#{"name": "em_home-col-1-large-2-small", "space": "267357", "uid": "b12e47d7-7cb7-4b24-9b52-f98c0502f104", "id": "522364930"}-->',
      },
      {
        _uid: '1ebaa1e5-c52a-4d71-a75e-2d329a872b7d',
        component: 'em_home-col-2-medium',
        medium_cards: [
          {
            _uid: '8172ea52-86f0-4872-b192-601bc756ff1d',
            link: {
              id: '',
              url: '/404',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: '/404',
            },
            is_dark: true,
            component: 'em_home--card-medium',
            text_layout: 'overline_headline',
            back_side_cta: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            interactivity: 'link',
            back_side_text: '',
            front_side_image: {
              id: 16640937,
              alt: 'A photo of a coffee machine',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename: 'https://a.storyblok.com/f/267357/1252x1464/9d23371c8b/em_home-coffee-machine.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A photo of a coffee machine',
                title: '',
                source: '',
                copyright: '',
              },
              is_private: false,
              is_external_url: false,
            },
            front_side_video: {
              id: null,
              alt: null,
              name: '',
              focus: null,
              title: null,
              source: null,
              filename: '',
              copyright: null,
              fieldtype: 'asset',
              meta_data: {},
            },
            front_side_subline: '',
            front_side_headline: 'We design to last.',
            front_side_overline: 'Made in Germany',
            vertical_text_align: 'top',
            _editable:
              '<!--#storyblok#{"name": "em_home--card-medium", "space": "267357", "uid": "8172ea52-86f0-4872-b192-601bc756ff1d", "id": "522364930"}-->',
          },
          {
            _uid: '6ab15b8b-864a-4592-9f5f-b9d5dbe5d574',
            link: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            is_dark: false,
            component: 'em_home--card-medium',
            text_layout: 'headline_subline',
            back_side_cta: {
              id: '',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: '',
            },
            interactivity: 'none',
            back_side_text: '',
            front_side_image: {
              id: 16640939,
              alt: 'A glass of milk',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename: 'https://a.storyblok.com/f/267357/721x721/36a6e0b075/em_home-milk.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A glass of milk',
                title: '',
                source: '',
                copyright: '',
              },
              is_private: false,
              is_external_url: false,
            },
            front_side_video: {
              id: null,
              alt: null,
              name: '',
              focus: null,
              title: null,
              source: null,
              filename: '',
              copyright: null,
              fieldtype: 'asset',
              meta_data: {},
            },
            front_side_subline: 'Best milk options.',
            front_side_headline: 'Basic. Smart. Easy. Dynamic.',
            front_side_overline: '',
            vertical_text_align: 'top',
            _editable:
              '<!--#storyblok#{"name": "em_home--card-medium", "space": "267357", "uid": "6ab15b8b-864a-4592-9f5f-b9d5dbe5d574", "id": "522364930"}-->',
          },
        ],
        _editable:
          '<!--#storyblok#{"name": "em_home-col-2-medium", "space": "267357", "uid": "1ebaa1e5-c52a-4d71-a75e-2d329a872b7d", "id": "522364930"}-->',
      },
    ],
    footer_headline: {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
          content: [
            {
              text: 'Designed to ',
              type: 'text',
              marks: [{ type: 'textStyle', attrs: { color: '' } }],
            },
            {
              text: 'perform.',
              type: 'text',
              marks: [
                { type: 'styled', attrs: { class: 'text-brown' } },
                { type: 'textStyle', attrs: { color: '' } },
              ],
            },
          ],
        },
      ],
    },
    _editable:
      '<!--#storyblok#{"name": "em_home", "space": "267357", "uid": "3ee60d5e-560f-4858-88c3-d8382544a73e", "id": "522364930"}-->',
  },
  footerBlok: {
    _uid: 'd72825f3-888a-413b-adb5-850321c40dda',
    texts: [
      {
        _uid: '83bfca16-8cfd-485f-9952-5d4e90b968cf',
        text: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                { text: 'WMF is part of', type: 'text' },
                {
                  text: ' ',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: 'https://www.groupeseb.com/en',
                        uuid: null,
                        anchor: null,
                        target: '_self',
                        linktype: 'url',
                      },
                    },
                  ],
                },
                {
                  text: 'Groupe',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: 'https://www.groupeseb.com/en',
                        uuid: null,
                        anchor: null,
                        target: '_self',
                        linktype: 'url',
                      },
                    },
                    { type: 'bold' },
                  ],
                },
                {
                  text: ' ',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: 'https://www.groupeseb.com/en',
                        uuid: null,
                        anchor: null,
                        target: '_self',
                        linktype: 'url',
                      },
                    },
                  ],
                },
                {
                  text: 'SEB Professional',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: 'https://www.groupeseb.com/en',
                        uuid: null,
                        anchor: null,
                        target: '_self',
                        linktype: 'url',
                      },
                    },
                    { type: 'bold' },
                  ],
                },
                { text: '.', type: 'text', marks: [{ type: 'bold' }] },
              ],
            },
            {
              type: 'paragraph',
              content: [
                { text: 'WMF GmbH', type: 'text' },
                { type: 'hard_break' },
                { text: 'WMF Platz 1, ', type: 'text' },
                { type: 'hard_break' },
                { text: '73312Geislingen - ', type: 'text' },
                {
                  text: 'Germany',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
          ],
        },
        component: 'util_richtext-light',
        _editable:
          '<!--#storyblok#{"name": "util_richtext-light", "space": "267357", "uid": "83bfca16-8cfd-485f-9952-5d4e90b968cf", "id": "455377948"}-->',
      },
    ],
    columns: [
      {
        _uid: 'f82ec5c4-2bb8-4949-92fe-72b4ba0ce8c9',
        items: [
          {
            _uid: 'aef797a2-5567-4cea-b23f-31a05275283d',
            link: {
              id: '',
              url: 'https://github.com/',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: 'https://github.com/',
            },
            text: 'Products',
            component: 'util_link-item',
            _editable:
              '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "aef797a2-5567-4cea-b23f-31a05275283d", "id": "455377948"}-->',
          },
          {
            _uid: '717aa737-172f-4d29-8d1a-edd7b69dcc97',
            link: {
              id: '9a02ad53-6fd7-4e85-a8e0-754ace052351',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/add-ons/sirup-station',
            },
            text: 'Pick a Service',
            component: 'util_link-item',
            _editable:
              '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "717aa737-172f-4d29-8d1a-edd7b69dcc97", "id": "455377948"}-->',
          },
          {
            _uid: '768a3044-7336-4a94-8c95-e43a19df974c',
            link: {
              id: '9a02ad53-6fd7-4e85-a8e0-754ace052351',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/add-ons/sirup-station',
            },
            text: 'Digital Solution',
            component: 'util_link-item',
            _editable:
              '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "768a3044-7336-4a94-8c95-e43a19df974c", "id": "455377948"}-->',
          },
          {
            _uid: '49644667-4f8a-4cef-af03-a8b2e7404d92',
            link: {
              id: '9a02ad53-6fd7-4e85-a8e0-754ace052351',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/add-ons/sirup-station',
            },
            text: 'Industries & More',
            component: 'util_link-item',
            _editable:
              '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "49644667-4f8a-4cef-af03-a8b2e7404d92", "id": "455377948"}-->',
          },
          {
            _uid: '271cf431-8ee4-464f-8170-42bedf1fca1b',
            link: {
              id: '9a02ad53-6fd7-4e85-a8e0-754ace052351',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/add-ons/sirup-station',
            },
            text: 'Why WMF',
            component: 'util_link-item',
            _editable:
              '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "271cf431-8ee4-464f-8170-42bedf1fca1b", "id": "455377948"}-->',
          },
          {
            _uid: 'aeb39635-00ec-4ea8-a928-61fdb675c2fe',
            link: {
              id: '9a02ad53-6fd7-4e85-a8e0-754ace052351',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/add-ons/sirup-station',
            },
            text: 'Get in Touch',
            component: 'util_link-item',
            _editable:
              '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "aeb39635-00ec-4ea8-a928-61fdb675c2fe", "id": "455377948"}-->',
          },
        ],
        component: 'util_link-list',
        _editable:
          '<!--#storyblok#{"name": "util_link-list", "space": "267357", "uid": "f82ec5c4-2bb8-4949-92fe-72b4ba0ce8c9", "id": "455377948"}-->',
      },
      {
        _uid: 'd3b0ff5a-406f-4050-8edc-02289d640abc',
        items: [
          {
            _uid: 'da6c432a-e970-49b8-8648-5707fc2594e8',
            icon: 'fi_phone',
            link: {
              id: '',
              url: 'tel:+00497331258482',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: 'tel:+00497331258482',
            },
            text: '00 49 7331 258 482',
            subtext: '',
            component: 'util_link-item-icon',
            icon_position: 'start',
            is_text_hidden_on_mobile: false,
            _editable:
              '<!--#storyblok#{"name": "util_link-item-icon", "space": "267357", "uid": "da6c432a-e970-49b8-8648-5707fc2594e8", "id": "455377948"}-->',
          },
          {
            _uid: 'ddc05d6a-db7d-428a-85c0-82492b14a51e',
            icon: 'fi_mail',
            link: {
              id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/contact',
            },
            text: 'Get in Touch',
            component: 'util_link-item-icon',
            icon_position: 'start',
            _editable:
              '<!--#storyblok#{"name": "util_link-item-icon", "space": "267357", "uid": "ddc05d6a-db7d-428a-85c0-82492b14a51e", "id": "455377948"}-->',
          },
          {
            _uid: 'cc0ce19b-0c26-4852-923d-c7d8414bfcb0',
            icon: 'fi_linkedin',
            link: {
              id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/contact',
            },
            text: 'Linkedin',
            component: 'util_link-item-icon',
            icon_position: 'start',
            is_text_hidden_on_mobile: true,
            _editable:
              '<!--#storyblok#{"name": "util_link-item-icon", "space": "267357", "uid": "cc0ce19b-0c26-4852-923d-c7d8414bfcb0", "id": "455377948"}-->',
          },
          {
            _uid: '01684f6e-b7f8-49cb-8b9a-9f24d9bb5c2c',
            icon: 'fi_youtube',
            link: {
              id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/contact',
            },
            text: 'Youtube',
            component: 'util_link-item-icon',
            icon_position: 'start',
            is_text_hidden_on_mobile: true,
            _editable:
              '<!--#storyblok#{"name": "util_link-item-icon", "space": "267357", "uid": "01684f6e-b7f8-49cb-8b9a-9f24d9bb5c2c", "id": "455377948"}-->',
          },
          {
            _uid: '3fe33378-7f41-4fa7-bf0d-ac7c0089c12a',
            icon: 'fi_twitter',
            link: {
              id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/contact',
            },
            text: 'Twitter',
            component: 'util_link-item-icon',
            icon_position: 'start',
            is_text_hidden_on_mobile: true,
            _editable:
              '<!--#storyblok#{"name": "util_link-item-icon", "space": "267357", "uid": "3fe33378-7f41-4fa7-bf0d-ac7c0089c12a", "id": "455377948"}-->',
          },
          {
            _uid: 'aaf2a688-93aa-4a91-b468-870ba44430a8',
            icon: 'fi_arrow-right-1',
            link: {
              id: '',
              url: 'http://github.com/',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: 'http://github.com/',
            },
            text: 'Link extern',
            component: 'util_link-item-icon',
            item_overlay: '',
            icon_position: 'end',
            is_text_hidden_on_mobile: false,
            _editable:
              '<!--#storyblok#{"name": "util_link-item-icon", "space": "267357", "uid": "aaf2a688-93aa-4a91-b468-870ba44430a8", "id": "455377948"}-->',
          },
        ],
        component: 'util_link-list',
        _editable:
          '<!--#storyblok#{"name": "util_link-list", "space": "267357", "uid": "d3b0ff5a-406f-4050-8edc-02289d640abc", "id": "455377948"}-->',
      },
      {
        _uid: 'b5c10b96-82db-48ce-b58f-8e2278a04d0a',
        text: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Stay up to date with our innovative products, services and trade fair events.',
                  type: 'text',
                },
              ],
            },
          ],
        },
        component: 'util_richtext',
        call_to_actions: [
          {
            _uid: '134785c1-aa10-472c-a380-361bb36640ee',
            icon: '',
            link: {
              id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
              url: '',
              linktype: 'story',
              fieldtype: 'multilink',
              cached_url: 'nl_nl/contact',
            },
            size: 'large',
            text: 'Subscribe',
            theme: 'primary',
            component: 'util_button',
            _editable:
              '<!--#storyblok#{"name": "util_button", "space": "267357", "uid": "134785c1-aa10-472c-a380-361bb36640ee", "id": "455377948"}-->',
          },
        ],
        _editable:
          '<!--#storyblok#{"name": "util_richtext", "space": "267357", "uid": "b5c10b96-82db-48ce-b58f-8e2278a04d0a", "id": "455377948"}-->',
      },
    ],
    component: 'bm_footer',
    logo_black: {
      id: 14288617,
      alt: '',
      name: '',
      focus: '',
      title: '',
      source: '',
      filename: 'https://a.storyblok.com/f/267357/88x110/f0c5dc1470/wmf_logo_black.svg',
      copyright: '',
      fieldtype: 'asset',
      meta_data: {},
      is_private: false,
      is_external_url: false,
    },
    logo_white: {
      id: 14287884,
      alt: '',
      name: '',
      focus: '',
      title: '',
      source: '',
      filename: 'https://a.storyblok.com/f/267357/88x110/907d66b798/wmf_logo_white.svg',
      copyright: '',
      fieldtype: 'asset',
      meta_data: {},
      is_private: false,
      is_external_url: false,
    },
    legal_links: [
      {
        _uid: '84ace906-1df3-4533-81b8-39da6cc794e9',
        link: {
          id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
          url: '',
          linktype: 'story',
          fieldtype: 'multilink',
          cached_url: 'nl_nl/contact',
        },
        text: 'Privacy Statement ',
        component: 'util_link-item',
        _editable:
          '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "84ace906-1df3-4533-81b8-39da6cc794e9", "id": "455377948"}-->',
      },
      {
        _uid: '3a8b3cc2-0c95-44d0-8d4f-b1e438e9e4c6',
        link: {
          id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
          url: '',
          linktype: 'story',
          fieldtype: 'multilink',
          cached_url: 'nl_nl/contact',
        },
        text: 'Terms & Conditions',
        component: 'util_link-item',
        _editable:
          '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "3a8b3cc2-0c95-44d0-8d4f-b1e438e9e4c6", "id": "455377948"}-->',
      },
      {
        _uid: '44038ab6-acb2-421a-8476-32671ed8163d',
        link: {
          id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
          url: '',
          linktype: 'story',
          fieldtype: 'multilink',
          cached_url: 'nl_nl/contact',
        },
        text: 'Legal Notice',
        component: 'util_link-item',
        _editable:
          '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "44038ab6-acb2-421a-8476-32671ed8163d", "id": "455377948"}-->',
      },
      {
        _uid: 'ab8b90c4-c681-4946-9a5a-55f2e66ebd06',
        link: {
          id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
          url: '',
          linktype: 'story',
          fieldtype: 'multilink',
          cached_url: 'nl_nl/contact',
        },
        text: 'Corporate Compliance',
        component: 'util_link-item',
        _editable:
          '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "ab8b90c4-c681-4946-9a5a-55f2e66ebd06", "id": "455377948"}-->',
      },
      {
        _uid: '0a84bea8-b880-44b0-b16d-10b053784db9',
        link: {
          id: '245264e5-42a3-4548-8fcb-caeb81ea33ba',
          url: '',
          linktype: 'story',
          fieldtype: 'multilink',
          cached_url: 'nl_nl/contact',
        },
        text: 'Corporate Compliance',
        component: 'util_link-item',
        _editable:
          '<!--#storyblok#{"name": "util_link-item", "space": "267357", "uid": "0a84bea8-b880-44b0-b16d-10b053784db9", "id": "455377948"}-->',
      },
    ],
    legal_copyright_text: '© 2024 WMF - All rights reserved.',
    legal_cookieconsent_text: 'Legal text',
    _editable:
      '<!--#storyblok#{"name": "bm_footer", "space": "267357", "uid": "d72825f3-888a-413b-adb5-850321c40dda", "id": "455377948"}-->',
  },
};
